import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { AuthTokensService } from '../auth-tokens.service';

@Injectable()
export class BrowserSessionTokenInterceptor implements HttpInterceptor {
	sessionToken;
	browserToken;
	cloned;
	constructor(private authTokensService: AuthTokensService) {
		this.sessionToken = uuidv4();
		this.browserToken = localStorage.getItem('BrowserToken');
		if (!this.browserToken) {
			localStorage.setItem('BrowserToken', uuidv4());
		}
	}

	intercept(
		req: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		this.cloned = req;

		const photographerEmailToken = localStorage.getItem('PhotographerEmail');
		if (this.authTokensService.isToken(req.url, this.sessionToken)) {
			if (this.sessionToken) {
				this.cloned = req.clone({
					headers: req.headers.set('SessionToken', this.sessionToken)
				});
			}
		}

		if (this.authTokensService.isToken(req.url, this.browserToken)) {
			if (this.browserToken) {
				this.cloned = this.cloned.clone({
					headers: this.cloned.headers.set('BrowserToken', this.browserToken)
				});
			}
		}

		if (this.authTokensService.isToken(req.url, photographerEmailToken)) {
			if (photographerEmailToken) {
				this.cloned = this.cloned.clone({
					headers: this.cloned.headers.set(
						'PhotographerEmail',
						photographerEmailToken
					)
				});
			}
		}
		return next.handle(this.cloned);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/interceptors/browserSessionToken.interceptor.ts